import dateConvert from "common/helper/dateConvert";
import NestedData from "common/framework/NestedData";
/**
 * This is an extension of the default kendo Model.
 *
 * It supports additional features.
 *
 * It has features to support transient fields.
 *
 * It has features to support nested fields.
 *
 * All fields can add support for the "nested" property.  It is configured like so:
 *
 * field: {
 *    nested: {
 *       root: "property",
 *       idField: "name"
 *       id: "someNameValue"
 *       valueField: "value"
 *    },
 *    defaultValue: "test"
 * }
 *
 * This was cause an input like the following to work
 *
 * {
 *  property: [
 *   {name: "someNameValue", value: "Some actual value"}
 *  ]
 *  }
 *
 *  A call go model.get("field") will find the right data.
 *  A call to toJSON() will produce the right output.
 *
 *
 *  It has support for nested arrays.
 *  field: {
 *      datasource: {
 *          model: Model // Defaults to Model
 *          dsName: "nestedDS" // defaults to field + "DS"
 *      }
 *  }
 *
 * It has support nested objects->sub models.  The sub model will always be created. It will created with the name -> field + "Model"
 * field: {
 *      model: Model
 * }
 *
 *
 * NestedData has special supported for "ordinal" fields.  If there is a model with an ordinal field and calculated is set to true, the Model will include the appropriate ordinal
 * even if the source data does not include it.
 *
 * field: {
 *     name: "ordinal",
 *     calculated: true
 * }
 */
var Model = kendo.data.Model.extend({

    init: function() {
        this.unsavedChanges = false;
        this._transient = {};
        this._nested = {};
        this._ds = {};
        this._dsFields = {};
        this._models = {};
        this._modelFields = {};
        kendo.data.Model.fn.init.apply(this, arguments);
        this.bind("change", this._trackUnsavedChanges);
        var nested = false;
        var ds = false;
        var model = false;
        for (var f in this.fields) {
            if (this.fields[f] && this.fields[f].hasOwnProperty("transient") && this.fields[f].transient) {
                this.markTransient(f);
            } else if (this.fields[f] && this.fields[f].hasOwnProperty("nested")) {
                this._configNested(f, this.fields[f].nested);
                nested = true;
            } else if (this.fields[f] && this.fields[f].hasOwnProperty("datasource")) {
                this._configDS(f, this.fields[f].datasource);
                ds = true;
            } else if (this.fields[f] && this.fields[f].hasOwnProperty("model")) {
                this._configModel(f, this.fields[f].model);
                model = true;
            } else if (this.fields[f] && this.fields[f].hasOwnProperty("subModel")) {
                this.fields[f].parse = (function(SubModel) {
                    return function(value) {
                        if (value instanceof SubModel) {
                            value = value.toJSON();
                        }
                        return (value != null) ? new SubModel(value) : undefined;
                    };
                })(this.fields[f].subModel);
            }
        }
        if (nested) {
            this.bind("accept", this._syncFromNested);
        }
        if (ds) {
            this.bind("accept", this._syncFromDSSource);
        }
        if (model) {
            this.bind("accept", this._syncFromModelSource);
        }
        this.trigger("accept");
    },

    _trackUnsavedChanges: function(e) {
        if (!this.unsavedChanges) {
            var field = e.field;
            var action = e.action;
            if (field && this._dsFields.hasOwnProperty(field)) {
                if (action === "itemchange" && e.items && e.items.length) {
                    this.set("unsavedChanges", this.unsavedChanges || e.items[0].unsavedChanges);
                } else if (action === "add" || action === "remove") {
                    this.set("unsavedChanges", true);
                }
            } else if (field && field.indexOf(".unsavedChanges") >= 0) {
                var childField = field.replace(/^([a-zA-Z0-9]+)\.unsavedChanges$/, "$1");
                if (this._modelFields.hasOwnProperty(childField)) {
                    this.set("unsavedChanges", this.unsavedChanges || this[childField].unsavedChanges);
                }
            } else if (field && this._modelFields.hasOwnProperty(field)) {
                this.set("unsavedChanges", this.unsavedChanges || this[field].unsavedChanges);
            } else if (field && field.indexOf(".") === -1 && field !== "unsavedChanges" && !this._transient.hasOwnProperty(field)) {
                this.set("unsavedChanges", true);
            }
        }
    },

    /**
     * Reset the unsavedChanges flag on this model all children models.
     */
    resetUnsavedChanges: function() {
        for (var modelField in this._modelFields) {
            if (this._modelFields.hasOwnProperty(modelField) && this[modelField]) {
                this[modelField].resetUnsavedChanges();
            }
        }
        for (var dsField in this._dsFields) {
            if (this._dsFields.hasOwnProperty(dsField) && this[dsField]) {
                this[dsField].data()
                    .forEach(function(model) {
                        model.resetUnsavedChanges();
                    });
            }
        }
        this.set("unsavedChanges", false);
    },


    /**
     * Config a field as the data coming to/from a nested field.
     * @param to
     * @param config
     * @private
     */
    _configNested: function(to, config) {
        if (!config.id) {
            config.id = to;
        }
        if (!config.idField) {
            config.idField = "name"
        }
        if (!config.valueField) {
            config.valueField = "value"
        }
        this._nested[to] = config;
    },

    /**
     * Sync the appropriate value from nested containerns to appropriate fields.
     * @private
     */
    _syncFromNested: function() {
        for (var field in this._nested) {
            var config = this._nested[field];
            var nested = this[config.root];
            var found = false;
            if (nested) {
                for (var i = 0; i < nested.length; i++) {
                    if (nested[i][config.idField] == config.id) {
                        this[field] = this.fields[field].parse(nested[i][config.valueField]);
                        found = true;
                        break;
                    }
                }
            }
            if (!found) {
                this[field] = this.fields[field].defaultValue;
            }
        }
    },

    /**
     * Sync the current value of all nested fields to the appropriate container.
     * @private
     */
    _syncToNested: function() {
        for (var field in this._nested) {
            this._syncSingleToNested(field);
        }
    },

    /**
     * Sync a single field to the appropriate nested container.
     * @param field field
     * @private
     */
    _syncSingleToNested: function(field) {
        var config = this._nested[field];
        if (this[field] === this.fields[field].defaultValue || this[field] === undefined) {
            if (this[config.root]) {
                this[config.root] = this[config.root].filter(function(prop) {
                    return prop[config.idField] !== config.id;
                });
            }
            return;
        }

        if (!this[config.root]) {
            this[config.root] = [];
        }

        var nested = this[config.root];
        for (var i = 0; i < nested.length; i++) {
            if (nested[i][config.idField] == config.id) {
                nested[i][config.valueField] = this[field];
                return;
            }
        }

        var def = {};
        def[config.idField] = config.id;
        def[config.valueField] = this[field];
        nested.push(def);
    },

    /**
     * Configure datasource properties.
     * @param field
     * @param config
     * @private
     */
    _configDS: function(field, config) {
        this._ds[field] = {
            model: config.model ? config.model : Model.define({
                id: "id"
            }),
            dsName: config.dsName ? config.dsName : field + "DS",
            sort: config.sort,
            filter: config.filter,
            lazy: !!config.lazy
        };
        this._dsFields[this._ds[field].dsName] = field;
        this.set(this._ds[field].dsName, new NestedData({
            sort: this._ds[field].sort,
            filter: this._ds[field].filter,
            schema: {
                model: this._ds[field].model
            },
            useMarkedForDelete: config.useMarkedForDelete !== false
        }));
    },

    /**
     * Get the data from the backing array and put it in the datasource.
     * @private
     */
    _syncFromDSSource: function() {
        for (var field in this._ds) {
            var config = this._ds[field];
            var ds = this.get(config.dsName);
            var data = this[field] || [];
            ds.localData(data);
            if (!config.lazy) {
                ds.read();
            }
        }
    },

    /**
     * Get data out of NestedData and place it correctly on the model.
     * @private
     */
    _syncToDSSource: function() {
        for (var field in this._ds) {
            var config = this._ds[field];
            var ds = this.get(config.dsName);
            this[field] = ds.localData();
        }
    },

    /**
     * Configure a sub model.
     * @param field
     * @param SubModel
     * @private
     */
    _configModel: function(field, SubModel) {
        this._models[field] = {
            model: SubModel,
            modelField: field + "Model"
        };
        this._modelFields[field + "Model"] = field;
        this.set(this._models[field].modelField, new SubModel());
    },

    /**
     * Sync data from the raw object to the sub model.
     * @private
     */
    _syncFromModelSource: function() {
        for (var field in this._models) {
            if (this[field]) {
                this[this._models[field].modelField].accept(JSON.parse(JSON.stringify(this[field])));
            }
        }
    },

    /**
     * Sync data from the sub model to the raw object.
     * @private
     */
    _syncToModelSource: function() {
        for (var field in this._models) {
            this[field] = this[this._models[field].modelField].toJSON();
        }
    },

    /**
     * Version of setter that skips over transient fields.
     */
    set: function(field) {
        if (this._modelFields.hasOwnProperty(field) || this._dsFields.hasOwnProperty(field)) {
            var res = kendo.data.ObservableObject.fn.set.apply(this, arguments);
            this.dirty = this.dirty || this.get("unsavedChanges");
            return res;
        } else if (this._transient.hasOwnProperty(field) || field === "unsavedChanges") {
            return kendo.data.ObservableObject.fn.set.apply(this, arguments);
        } else {
            return kendo.data.Model.fn.set.apply(this, arguments);
        }
    },
    shouldSerialize: function(field) {
        if (field === "_transient" || this._transient.hasOwnProperty(field) || field === "unsavedChanges" || field === "_nested" || this._nested.hasOwnProperty(field) || field === "_ds" || field === "_dsFields" || this._dsFields.hasOwnProperty(field) || field === "_models" || field === "_modelFields" || this._modelFields.hasOwnProperty(field)) {
            return false;
        } else {
            return kendo.data.Model.fn.shouldSerialize.apply(this, arguments);
        }
    },

    accept: function() {
        kendo.data.Model.fn.accept.apply(this, arguments);
        this.trigger("accept");
        this.set("unsavedChanges", false);
    },

    toJSON: function() {
        this._syncToNested();
        this._syncToDSSource();
        this._syncToModelSource();
        var ret = kendo.data.Model.fn.toJSON.call(this);
        delete ret.__state__;
        return ret;
    },

    /**
     * Mark a property as being transient.
     * @param field
     */
    markTransient: function(field) {
        this._transient[field] = true;
    }
});

Model.define = function(opt) {
    var res = kendo.data.Model.define.call(this, Model, opt);
    res.define = function(o) {
        return kendo.data.Model.define.call(this, res, o)
    };
    return res;
};

Model.parseMomentInTime = function(value) {
    return value ? dateConvert.toDateUsingClientsTimeZone(value) : undefined;
};

export default Model;
